import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, CDN_URL, formatDate, getInlineLoader } from "../Helpers"
import { FaArrowLeft } from "react-icons/fa"
import { MdPerson } from "react-icons/md"

export default function ViewStaff({ uuid }) {

	const appContext = useContext(AppContext);

	const [ ready, setReady ] = useState(false);
	const [ data, setData ] = useState(null);

	async function init() {
		setReady(false);
		await Promise.all([
			getData(),
		])
		setReady(true);
	}

	async function getData() {
		await callApi('get-staff-data', { uuid }).then((response) => {
			if(response.status === 1) {
				setData(response.data);
			} else {
				appContext.tellError("Could not fetch data");
			}
		})
	}

	useEffect(() => {
		init();
	}, []);

	const photoUrl = (data && data.photo) ? (CDN_URL + data.photo) : null;

	if (ready && data) {
		return (
			<div className="container my-5">

				<div className="row justify-content-center">
					<div className="col-lg-9 col-xl-8">

						{/* Back */}
						<div
							style={{
								marginBottom: "14px",
								display: "flex",
								alignItems: "center",
								gap: "10px",
								cursor: "pointer",
								color: "rgba(255,255,255,0.7)"
							}}
							onClick={() => appContext.navBack()}
							className="font-semi-bold text-primary"
						>
							<FaArrowLeft />
							Back
						</div>

						{/* Header Card */}
						<div
							style={{
								borderRadius: "18px",
								overflow: "hidden",
								background: "#0b0f16",
								border: "1px solid rgba(255,255,255,0.08)",
								boxShadow: "0 18px 45px rgba(0,0,0,0.35)",
							}}
						>

							{/* Media */}
							<div
								style={{
									height: "360px",
									background: photoUrl
										? `url(${photoUrl})`
										: "linear-gradient(135deg, #1f2933, #0b0f16)",
									backgroundPosition: "center",
									backgroundSize: "cover",
									position: "relative",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>

								{/* Icon fallback */}
								{!photoUrl && (
									<div
										style={{
											width: "120px",
											height: "120px",
											borderRadius: "999px",
											background: "rgba(255,255,255,0.08)",
											border: "1px solid rgba(255,255,255,0.12)",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
									>
										<MdPerson
											style={{
												fontSize: "64px",
												color: "rgba(255,255,255,0.85)",
											}}
										/>
									</div>
								)}

								{/* Fade */}
								<div
									style={{
										position: "absolute",
										inset: 0,
										background:
											"linear-gradient(180deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.15) 40%, rgba(0,0,0,0.92) 100%)",
									}}
								/>

								{/* Bottom identity */}
								<div
									style={{
										position: "absolute",
										left: 0,
										right: 0,
										bottom: 0,
										padding: "18px",
									}}
								>
									<div
										style={{
											display: "flex",
											alignItems: "center",
											justifyContent: "space-between",
											gap: "12px",
											marginBottom: "8px",
										}}
									>
										<div
											style={{
												fontSize: "12px",
												letterSpacing: "0.6px",
												color: "rgba(255,255,255,0.60)",
											}}
											className="font-semi-bold"
										>
											STAFF
										</div>

										<div
											style={{
												fontSize: "12px",
												color: "rgba(255,255,255,0.60)",
											}}
											className="font-semi-bold"
										>
											{formatDate(data.dateCreated)}
										</div>
									</div>

									<h4
										style={{
											margin: 0,
											color: "#fff",
											lineHeight: "1.25",
											textShadow: "0 10px 26px rgba(0,0,0,0.45)",
										}}
										className="font-bold"
									>
										{data.fullname}
									</h4>

									<div
										style={{
											marginTop: "6px",
											color: "rgba(255,255,255,0.78)",
											fontSize: "14px",
											textShadow: "0 10px 26px rgba(0,0,0,0.45)",
										}}
										className="font-semi-bold"
									>
										{data.role}
									</div>
								</div>

							</div>

							{/* Body */}
							<div style={{ padding: "18px" }}>

								<div
									style={{
										display: "flex",
										alignItems: "center",
										justifyContent: "space-between",
										gap: "12px",
										marginBottom: "12px",
									}}
								>
									<div
										style={{
											fontSize: "12px",
											color: "rgba(255,255,255,0.55)",
											letterSpacing: "0.5px",
										}}
										className="font-semi-bold"
									>
										PROFILE
									</div>

									
								</div>

								

							</div>

						</div>

					</div>
				</div>

			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
